

export const AUTH = {
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	SET_CURRENT_USER: 'SET_CURRENT_USER'
}

export const INIT = {
	INIT: 'INIT'
} 